<template>
  <div :class="$options.name">
    <div v-for="col in columns"
      :key="col.key"
      :class="['ak-table-row__col', { 'ak-table-row__col--center': col.center }]"
      :style="colStyle(col)"
      :data-label="col.label || col.key">
      <slot :name="col.key"
        :item="item"
        :value="item[col.key]">
        <span v-if="item[col.key] != null"
          :ref="'col-' + col.key"
          class="ak-table-row__text"
          :class="{ 'ak-table-row__text--clamp': col.maxLines }"
          :style="col.maxLines ? { '-webkit-line-clamp': col.maxLines } : {}"
          :title="isTruncated[col.key] ? colText(col) : undefined">{{ colText(col) }}</span>
        <template v-else>—</template>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ak-table-row',
  props: {
    columns: { type: Array, required: true },
    item: { type: Object, required: true },
  },
  data() {
    return {
      isTruncated: {}
    }
  },
  mounted() {
    this.$nextTick(() => this.checkTruncation())
  },
  methods: {
    colStyle(col) {
      if (col.width) return { flex: `0 0 ${col.width}` }
      if (col.flex) return { flex: col.flex }
      return {}
    },
    colText(col) {
      const val = `${col.prefix || ''}${this.item[col.key]}${col.suffix || ''}`
      if (col.maxLines && val.length < 10) return val
      return val
    },
    checkTruncation() {
      const result = {}
      for (const col of this.columns) {
        if (!col.maxLines) continue
        const refs = this.$refs['col-' + col.key]
        const el = Array.isArray(refs) ? refs[0] : refs
        if (el) {
          result[col.key] = el.scrollHeight > el.clientHeight
        }
      }
      this.isTruncated = result
    }
  }
}
</script>

<style lang="scss" scoped>
// Cell layout only. The surrounding padding and row chrome come from
// gentelella's .accordion-summary, which this sits inside.
.ak-table-row {
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--space-5);
  font-size: 13rem;
  color: var(--text-secondary);
}

.ak-table-row__col {
  flex: 1;
  min-width: 0;
}

.ak-table-row__col--center {
  text-align: center;
  display: flex;
  justify-content: center;
}

.ak-table-row__text--clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

// Below the header's breakpoint the row restacks as a labelled card, with the
// column header carried in via data-label.
@include max-screen(640) {
  .ak-table-row {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-1);
  }

  .ak-table-row__col {
    flex: none !important;
    width: 100%;
    display: flex;
    align-items: baseline;
    gap: var(--space-2);
  }

  .ak-table-row__col--center {
    justify-content: flex-start;
    text-align: left;
  }

  .ak-table-row__col::before {
    content: attr(data-label);
    flex: 0 0 auto;
    min-width: 80rem;
    font-size: 11rem;
    font-weight: var(--font-weight-bold);
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.3rem;
  }

  .ak-table-row__col:empty {
    display: none;
  }
}
</style>
